/* eslint-disable jsx-a11y/no-redundant-roles */
import { useEffect, useState } from 'react';
import throttle from '@/utils/throttle';

export default function BackTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = throttle(() => {
      if (window.scrollY > window.innerHeight * 0.75) {
        setShow(true);
      } else {
        setShow(false);
      }
    }, 400);

    window.addEventListener('scroll', onScroll, false);

    return () => {
      window.removeEventListener('scroll', onScroll, false);
    };
  }, [setShow]);

  return (
    <a
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      href="#"
      data-category="Button Click"
      data-action="Click"
      data-label="Top Button"
      data-acsb-clickable="true"
      data-acsb-navigable="true"
      tabIndex={-1}
      data-acsb-now-navigable="false"
      aria-hidden="true"
      data-acsb-hidden="true"
      data-acsb-hover="true"
      role="button"
      style={{ display: show ? 'inline' : 'none', textDecoration: 'underline' }}
      className="acsb-hover tw-fixed tw-z-[100] tw-w-[56px] tw-h-[56px] tw-right-[7px] tw-bottom-[27px] md:tw-right-[17px] md:tw-bottom-[36px] tw-hidden tw-cursor-pointer tw-outline-none focus:tw-outline-none"
    >
      <img
        width="93"
        height="93"
        className="tw-w-full tw-h-full"
        src="/bee2-ui/img/backtop-button-icon-only.svg"
        alt="Back to top"
        role="img"
      />
    </a>
  );
}
